import { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { FundContext } from '../FundPage';
import { FileText } from 'react-feather';
import PageGridItem from '../../../Shared/Page/PageGridItem';
import DetailTextbox from '../DetailTextbox'
import FlexWrapper from '../../../FlexWrapper';
import Checkbox from '../../../../components/Checkbox';
import DetailSectionHeader from '../../../Shared/DetailSection/DetailSectionHeader';
import Tooltip from '../../../../components/popups/Tooltip';
import "../FundPage.scss"


const FundDisclaimers = () => {
    const { fundId } = useParams()
    const { editMode, setEditMode, setSelectedTab, disclaimers, setDisclaimers } = useContext(FundContext)

    useEffect(() => {
        setSelectedTab("Note Disclaimers")
    }, [fundId])

    function updateDisclaimer(boolean, id) {
        const newList = disclaimers.map(note => {
            if (note.id === id) {
                const updatedNote = { ...note, selected: boolean }
                return updatedNote
            } else return note
        }).sort((a, b) => a.name.localeCompare(b.name));
        setDisclaimers(newList);
    }

    function disclaimersList(data) {
        if (data?.length > 0) {
            const hasSelected = data.find(n => n.selected)
            if (!hasSelected && !editMode) {
                return <p>No disclaimers selected for this fund. <span className='text-link' onClick={() => setEditMode(true)}>Select some disclaimers</span></p>
            } else {
                return data.map(disclaimer => {
                    const { id, selected, name, inherited, parent, footnoteSymbol } = disclaimer
                    const text = disclaimer.disclaimer || ""
                    const nameWithFootnote = footnoteSymbol
                        ? <Tooltip label={`Footnote symbol "${footnoteSymbol}" — shown as a superscript on this disclaimer and beside content referencing it`}>
                            <span>{name}<sup style={{ fontSize: '66%' }}>{footnoteSymbol}</sup></span>
                        </Tooltip>
                        : name
                    return (
                        editMode
                            ? <PageGridItem container gap='s' alignItems='baseline' style={{ paddingBottom: '1rem' }} key={id}>
                                {editMode &&
                                    <FlexWrapper gap='s' direction="row" style={{ height: '1.75rem', paddingTop: '0.25rem' }}>
                                        <Checkbox
                                            checked={selected}
                                            onChange={() => inherited ? null : updateDisclaimer(!selected, id)}
                                            className="delete-icon no-margin"
                                            disabled={inherited}
                                        />
                                        <p>
                                            <span className={inherited ? 'opacity-06' : ''}>{nameWithFootnote}</span>
                                            <span className='opacity-06'>{inherited ? " (inherited from " + parent + ")" : ""}</span>
                                        </p>
                                    </FlexWrapper>
                                }
                            </PageGridItem> : (!editMode && selected) &&
                            <PageGridItem container gap='s' row='2' style={{ display: 'grid', paddingBottom: '1.25rem' }} key={id}>
                                <p>
                                    <span className='font-weight-medium'>{nameWithFootnote}</span>
                                    <span className='opacity-06'>{inherited ? " (inherited from " + parent + ")" : ""}</span>
                                </p>
                            </PageGridItem>
                    )
                })
            }
        }
    }

    return (
        <>
            <PageGridItem container col="1 / span 8" gap='l' direction='col'>
                <DetailSectionHeader header="Disclaimers" icon={<FileText />} />
                <div>
                    {/* {notes?.length === 0 ? <p>No notes found on offer {fund?.offerNumber}. <span onClick={() => history.push(portfolio ? '/admin/portfolio-management/products/' + fund?.offerNumber + "/footnotes/" : '/admin/fund-management/offers/' + fund?.offerNumber)} className='text-link' href=''>Add some notes</span></p> : ""} */}
                    {disclaimersList(disclaimers)}
                </div>
            </PageGridItem>
        </>
    );
}

export default FundDisclaimers;